import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { Box, IconButton, Stack, Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import { useDefaultComponentTools } from '../../../hooks/useDefaultComponentTools'
import { setSidebarIsOpen } from '../../../store/redusers/sidebar/actions'
import {
	selectSidebarAssetName
} from '../../../store/redusers/sidebar/selectors'
import AppIconDouble from '../../AppIconDouble'

const SidebarHeader = () => {
	const { dispatch, theme } = useDefaultComponentTools(true)
	const sidebarAssetName = useSelector(selectSidebarAssetName)
	const onlCloseSidebar = () => {
		dispatch(setSidebarIsOpen(false))
	}

	return (
		<Box sx={{ alignItems: 'flex-start', display: 'flex'}}>
			<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
				<IconButton
					sx={{ color: theme.palette.text.secondary, p: '4px 8px'}}
					onClick={() => onlCloseSidebar()}
					component='label'
				>
					<ArrowForwardIosIcon />
				</IconButton>
			</Box>
			<Stack sx={{ alignItems: 'center', m: '0 70px', mb: 2 }} spacing={3}>
				<AppIconDouble name={sidebarAssetName} double={true} size={36} sxCustom={{ alignItems: 'center',
					justifyContent: 'center'}}/>
				<Typography variant='px16' sx={{textAlign: 'center'}}>
					{sidebarAssetName}</Typography>
			</Stack>

		</Box>
	)
}


export default SidebarHeader
